export default function AdSlot({ id, className = "" }) {
  // Reserved space for future AdSense placement. Currently empty per requirements.
  return <div className={`ad-slot ${className}`} data-testid={`ad-slot-${id}`} aria-hidden="true" />;
}
